import React from "react";
import { getDataHeroName, parseBuildRows } from "lib/wowHelpers";
import { getIcon } from "components/Pages/Builds/WOWBuildsContainer";
import { getParsedSelectedTalents, getSpecTreeAccessor } from "../../../lib/wowHelpers";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import WowTooltip from "components/Tooltips/WowTooltip";

const Talents = (props) => {
  const { data, talents, encounterType, hscombined } = props;

  const classAccessor = getSpecTreeAccessor(data.class);
  const specAccessor = getSpecTreeAccessor(data.spec);

  const { data: specData } = useJSONFetcher(`https://static.bigbrain.gg/wow/tree/v14/${classAccessor}_${specAccessor}.json`, {
    ssr: true,
  });

  if (!specData) {
    return null;
  }

  const talentAccessor = hscombined
    ? `${data.class + "-" + data.spec}`
    : encounterType === "pvp"
    ? `${data.class + "-" + data.spec + "-" + getDataHeroName(data.subspec_display_name)}`
    : `${data.class + "-" + data.spec + "-" + getDataHeroName(data.subspec)}`;
  const currentTalents = talents[talentAccessor]?.split("-") ?? [];
  const { selectedTalents, selectedTalentNodeIds } = getParsedSelectedTalents(currentTalents);
  const lastRowSpecs = parseBuildRows(specData.specNodes, selectedTalents, [10, 9, 8, 7]);

  return (
    <div className="talents-container">
      {/* This div is used in replacement of the wow tooltip container for now */}
      {lastRowSpecs.map((talent, index) => {
        let spellId, talentName, talentDescription;
        if (talent[1].spells.length > 1) {
          for (let i = 0; i < talent[1].spells.length; i++) {
            // Use nodeEntryId for data from WCL and the definition ID for data from the Blizzard API.
            if (
              selectedTalentNodeIds.includes(talent[1].spells[i].nodeEntryId.toString()) ||
              selectedTalentNodeIds.includes(talent[1].spells[i].definitionId.toString())
            ) {
              spellId = talent[1].spells[i].spellId;
              talentName = talent[1].spells[i].name;
              talentDescription = talent[1].spells[i].description;
            }
          }
        } else {
          spellId = talent[1].spells[0].spellId;
          talentName = talent[1].spells[0].name;
          talentDescription = talent[1].spells[0].description;
        }

        return (
          <WowTooltip type="spell" id={spellId}>
            {getIcon(2, spellId, "transparent", "30px", index)}
          </WowTooltip>
        );
      })}
    </div>
  );
};

export default Talents;
